import { createWebHistory, createRouter } from 'vue-router';
import ProductDetails from '@/components/ProductDetails.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
import Home from '@/components/Home.vue';
import ShoeFinder from '@/components/ShoeFinder.vue';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/product',
		name: 'ProductDetails',
		component: ProductDetails
	},
	{
		path: '/shoes',
		name: 'ShoeFinder',
		component: ShoeFinder
	},
	{
		path: '/privacy-policy',
		name: 'PrivacyPolicy',
		component: PrivacyPolicy
	},
	{
		path: '/dev',
		name: 'HomeDev',
		component: Home
	},
	{
		path: '/dev/product',
		name: 'ProductDetailsDev',
		component: ProductDetails
	},
	{
		path: '/dev/cat/:cat(.*)*',
		name: 'CategoryDev',
		component: Home
	},
	{
		path: '/cat/:cat(.*)*',
		name: 'Category',
		component: Home
	}
];

const router = createRouter({
	history: createWebHistory(),
	routes
});

export default router;